import { AppHeader as UiAppHeader, useLanguageContext } from '@mbd/ui-components';
import { useNavigate } from 'react-router';

export function AppHeader() {
  const { t, language, changeLang } = useLanguageContext();
  const navigate = useNavigate();

  return (
    <UiAppHeader
      appName={t('app_name')}
      t={t}
      onNavigate={(path) => navigate(path)}
      componentProps={{
        languageSwitcher: {
          language,
          onLanguageChange: changeLang,
        },
        navigation: {
          menuItems: [],
        },
      }}
    />
  );
}
